import { findMovieByID, findPosterByID } from "../scripts/fetchMovieImages";
import Papa from 'papaparse';

function parseCSVFileACB(csvFile) {
  return new Promise((resolve, reject) => {
    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      dynamicTyping: true,
      complete: (results) => resolve(results.data),
      error: (error) => reject(error)
    });
  });
}

export function csvParse(csvFile) {
  return parseCSVFileACB(csvFile);
}